import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import AIInsightCard from './AIInsightCard';

const AIInsightsPanel = ({ insights, isOpen, onToggle }) => {
  const [activeCategory, setActiveCategory] = useState('performance');

  const categories = [
    { id: 'performance', label: 'Performance', icon: 'Activity' },
    { id: 'financial', label: 'Financial', icon: 'DollarSign' },
    { id: 'workforce', label: 'Workforce', icon: 'Users' },
    { id: 'meta', label: 'Meta', icon: 'Brain' }
  ];

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        onClick={onToggle}
        className="lg:hidden fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-lg hover-lift focus-ring"
        aria-label="Toggle AI Insights"
      >
        <Icon name={isOpen ? 'X' : 'Brain'} size={24} />
      </button>

      {/* Mobile overlay backdrop */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-background/80 z-40"
          onClick={onToggle}
        />
      )}

      {/* Right Intelligence Rail */}
      <aside
        className={`
          fixed lg:sticky top-16 right-0
          h-[calc(100vh-4rem)]
          w-[300px] flex-shrink-0
          bg-card border-l border-border
          overflow-y-auto z-40
          transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'}
        `}
      >
        {/* Panel Header */}
        <div className="p-4 border-b border-border sticky top-0 bg-card z-10">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="flex items-center justify-center w-8 h-8 rounded-md bg-primary/10">
                <Icon name="Brain" size={16} color="var(--color-primary)" />
              </div>
              <div>
                <h3 className="text-sm font-heading font-semibold text-foreground">
                  AI Insights
                </h3>
                <p className="text-xs text-muted-foreground font-caption">
                  Real-time intelligence
                </p>
              </div>
            </div>
            <button
              onClick={onToggle}
              className="lg:hidden p-1.5 rounded-md hover:bg-muted transition-smooth focus-ring"
              aria-label="Close AI Insights"
            >
              <Icon name="X" size={16} />
            </button>
          </div>

          {/* Category Tabs */}
          <div className="grid grid-cols-2 gap-1.5">
            {categories?.map((category) => (
              <button
                key={category?.id}
                onClick={() => setActiveCategory(category?.id)}
                className={`
                  flex items-center gap-1.5 px-2 py-1.5 rounded-md text-xs font-medium font-caption
                  transition-smooth
                  ${activeCategory === category?.id
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                  }
                `}
              >
                <Icon name={category?.icon} size={12} />
                <span>{category?.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Insight Cards */}
        <div className="p-4 space-y-3">
          {insights?.[activeCategory]?.map((insight, index) => (
            <AIInsightCard key={index} {...insight} />
          ))}
        </div>
      </aside>
    </>
  );
};

export default AIInsightsPanel;